import React from "react";
import Wind from "./Wind";
import "./App.css";

export default function App() {
  return ( 
    <div className="App">
      <div className="container">
        <Wind />
        <footer>
            This project was coded by Adriana Pana and is{" "}
            <a href="https://github.com/AdrianaPana/react-wind-app" target="_blank" rel="noreferrer"> open-sourced on Github</a>
            {" "}and{" "}
            <a href="https://react-wind-app.netlify.app/" target="_blank" rel="noreferrer"> hosted on Netlify</a>
            </footer>
      </div>
    </div>
  );
}